module.exports = {
      id: "whatsapp-icon-usage",
      viewBox: "0 0 24.99 25.091",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#whatsapp-icon",
      toString: function () {
        return this.url;
      }
    }